// GENERATED BY process-svg DO NOT EDIT
import { GeneratedIcon } from './Icon'
import type { GeneratedIconProps } from './Icon/types'
// @ts-ignore
import Svg from './svg/ic-external-link-outline.svg?react'

export const IconExternalLinkOutline = (
  props: GeneratedIconProps,
): JSX.Element => (
  <GeneratedIcon {...props}>
    <Svg preserveAspectRatio="xMidYMid meet" />
  </GeneratedIcon>
)

IconExternalLinkOutline.displayName = 'IconExternalLinkOutline'
